<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import {
  isMasifiWaGroupContact,
  MASIFI_WA_GROUP_ICON,
} from 'dashboard/helper/masifiWaGroups';

// Ícono de grupo junto al nombre (lista y cabecera de la conversación; E2E fix batch 1). Nada para una persona.
const props = defineProps({ contact: { type: Object, default: () => ({}) } });
const { t } = useI18n();
const isGroup = computed(() => isMasifiWaGroupContact(props.contact));
</script>

<template>
  <span
    v-if="isGroup"
    data-test="masifi-wa-group-mark"
    role="img"
    :aria-label="t('MASIFI_WHATSAPP_QR.GROUPS.MARK')"
    :title="t('MASIFI_WHATSAPP_QR.GROUPS.MARK')"
    class="inline-flex flex-shrink-0 align-middle text-n-slate-11 ltr:mr-1 rtl:ml-1"
  >
    <Icon :icon="MASIFI_WA_GROUP_ICON" class="size-3.5" />
  </span>
</template>
